import { render, staticRenderFns } from "./union_list.vue?vue&type=template&id=7b0b006c&scoped=true"
import script from "./union_list.vue?vue&type=script&lang=ts"
export * from "./union_list.vue?vue&type=script&lang=ts"
import style0 from "./union_list.vue?vue&type=style&index=0&id=7b0b006c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0b006c",
  null
  
)

export default component.exports